<!--
Notification component
Usage: <NotifItem title="text" body="text" icon="fa-name" link="url" />
@author ab557z
-->
<template>
  <div class="eventDiv eventBox" @click="goToEvent()" ref="eventBox">

    <img src="@/assets/event_img.svg" class="eventBg" />
    <span>
      <h5 class="eventHeaderN">{{ title }}</h5>
    </span><br>

    <p class="eventBodyN">{{ eventDate }}</p>
    <p v-if="!isEmpty(eventTime)" class="eventBodyN">{{ eventTime }}</p><br>
    <span><img src="@/assets/index/location_details_solid.svg" class="eventLocIcon" /><p class="eventLoc blueLink">{{ loc }}</p></span>
    <span class="eventCategoryList"><p class="eventCategory">{{ allCategories }}</p></span>
    <font-awesome-icon style="color:#003865;" icon="arrow-right" size="sm" class="eventChev"></font-awesome-icon>

  </div>
</template>

<script setup>
//Utilities
import { ref, computed, defineExpose } from 'vue'
import { store } from '@/components/reactiveStore.js'
import { useRouter } from 'vue-router'
const router = useRouter()

//Composables
import { useStringUtil }  from '@/composables/StringMethods.js'
const { displayEventInfo, isEmpty } = useStringUtil();

const props = defineProps({
  title: String,
  body: Object,
  startDate: Number,
  endDate: Number,
  startTime: String,
  endTime: String,
  loc: String,
  event: Object
})

//Data
let evinfo = displayEventInfo(props.startDate, props.endDate, props.startTime, props.endTime)

const eventDate = ref(evinfo.date)
const eventTime = ref(evinfo.time)
const eventBox = ref(null)
    

//Computed
const allCategories = computed(() => {
  const cats = props.event.categories
  return cats.map((c) => { return c.name }).join(', ')
})

//Expose the ref eventBox so parent Events.vue can access the html element for scrolling to
defineExpose({
  eventBox
})

function goToEvent () {
  /*
    props: [
    'title', 'body', 'startDate', 
    'endDate', 'startTime', 'endTime', 
    'loc', 'event'],
  */
  store.put({
    event: props.event
  })
  router.push({
  //  name: 'singleClub', params: { 'club': this.club } }
    name: 'singleEvent'
  })
}

function prettyDate (date) {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
  var dateReady = new Date(date)
  return dateReady.toLocaleDateString('en-GB', options)
}

function checkMultiDate () {
  // var start = new Date(startDate)
  // var end = new Date(endDate)
  // if (start == end) return false
  // return true
  return false // until we get event end dates
}

</script>

<style scoped>
.eventCategoryList {
  margin-left:48px;
  overflow:hidden;
}
.eventCategory {
  display:inline-block;
  font-size:12px;
  color:#951272;
  padding-right:53px;
  overflow:hidden;
  margin-bottom:16px;
}
.eventLocIcon {
  margin-right:6px;
  margin-top:2px;
  margin-left:50px;
  float: left;
}
.eventLoc {
  overflow:hidden;
  margin-bottom:0px;
  margin-left:0px;
  margin-right:12px;
  font-size:12px;
  font-weight:400;
}
.eventSocial {
  display:inline-block;
  padding-left:48px;
  padding-bottom:20px;
}

.eventSocial img {
  margin-right:8px;
  margin-left:0px;
}

.eventChev {
  position:absolute;
  top:45%;
  right:16px;
}

.notificationIcon {
  z-index:999;
  position:absolute;
  color:#ffffff;
}

.eventBox {
border: 1px solid #e4e4e4;
box-sizing: border-box;
border-radius: 24px;
}

.eventDiv {
  margin-bottom:12px;
  padding:16px;
  padding-bottom:0px;
  padding-top:8px;
  position:relative;
}

.eventBg {
  position:absolute;
  left:10px;
  top:10px;
  z-index:-1;
}

.eventBodyN {
  font-size: 18px;
  color: #4F5961;
  padding-left:48px;
  padding-right:8%;
  margin-top:0px;
  margin-bottom:0px;
  display:block;
}

.eventHeaderN {
  font-style: normal;
  display:inline-block;
  padding-left:48px;
  font-weight: bold;
  font-size: 18px;
  line-height:21px;
  margin-top:4px;
  margin-bottom:0px;
  color: #003865;
}
</style>
